// extracted by mini-css-extract-plugin
export default {"project":"projects_project__Alx9U","container":"projects_container__4rJsH","projects_container":"projects_projects_container__n9Z06","main_text":"projects_main_text__8RW1l"};